
export {getCandidateAvatarColor};

function getCandidateAvatarColor(random: any) {
  
  return "";
}